module.exports = __webpack_public_path__ + "static/media/Estampa_Card4.836e74b5.png";